<div class="container">
    <div class="treatment-info-details"*ngFor="let detail of details, let i = index" >
        <div class="detail-container" *ngFor="let item of detail, let j = index">
            <span class="detail-header">{{ item.Prefix | translate }} {{ item.Name | translate }}:</span>
            <span>{{ item.Value | translate }}</span>
            <div *ngIf="j != detail.length-1" class="separator-subsection"></div>
        </div>
        <div *ngIf="i != details.length-1" class="separator treatment-info"></div>
    </div>
</div>